import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { toast } from "react-toastify";

import AppLayout from "../../components/layout/AppLayout";
import Breadcrumb from "../../components/layout/Breadcrumb";
import TurningReceiveForm from "../../components/turningReceives/TurningReceiveForm";
import { pageTitleClass } from "../../components/ui/styles";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  clearTurningReceiveOpenOrders,
  fetchTurningReceiveOpenOrders,
  fetchTurningReceiveParties,
  getTurningReceiveOpenOrders,
  getTurningReceiveOpenOrdersLoading,
  getTurningReceivePartyOptions,
} from "../../features/turningReceives/turningReceivesSlice";
import { getLoggingUser } from "../../features/loggingUser/loggingUserSlice";
import { POST } from "../../services/axios.service";
import { receiveLinePayload } from "../../static/cuttingLine";
import { hasPermission, permission } from "../../static/permission";
import { route } from "../../static/route";
import { toastStyles } from "../../static/styles";
import { BreadcrumbType } from "../../types/common";
import { ITurningReceiveFormInput } from "../../types/turningReceive";

const breadcrumbItems: BreadcrumbType[] = [
  { label: "હોમ", href: route.dashboard },
  { label: "ટર્નિંગ રિસીવ", href: route.turningReceives },
  { label: "નવી રિસીવ" },
];

const TurningReceiveCreatePage = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const partyOptions = useAppSelector(getTurningReceivePartyOptions);
  const openOrders = useAppSelector(getTurningReceiveOpenOrders);
  const openOrdersLoading = useAppSelector(getTurningReceiveOpenOrdersLoading);
  const loggingUser = useAppSelector(getLoggingUser);

  const withRates = hasPermission(
    loggingUser?.permissions,
    permission.turningRate
  );

  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    dispatch(fetchTurningReceiveParties());
    dispatch(clearTurningReceiveOpenOrders());
  }, [dispatch]);

  const handlePartyChange = useCallback(
    (partyId: number) => {
      if (partyId) {
        dispatch(fetchTurningReceiveOpenOrders({ party_id: partyId }));
      } else {
        dispatch(clearTurningReceiveOpenOrders());
      }
    },
    [dispatch]
  );

  const handleSubmit = async (data: ITurningReceiveFormInput) => {
    setIsSubmitting(true);
    try {
      await POST("/v1/admin/turning-receives", {
        party_id: data.party_id,
        date: moment(data.date).format("YYYY-MM-DD HH:mm:ss"),
        items: receiveLinePayload(data.items, withRates),
      })
        .then((response: any) => {
          if (response.data.status === "success") {
            toast.success(response.data.message, {
              ...(toastStyles as any),
            });
            navigate(route.turningReceives);
          } else {
            toast.error(response.data.message, {
              ...(toastStyles as any),
            });
          }
        })
        .catch((error: any) => {
          toast.error(error.data.message, {
            ...(toastStyles as any),
          });
        });
    } catch (error) {
      toast.error("કંઈક ખોટું ગયું, કૃપા કરીને ફરીથી પ્રયત્ન કરો.", {
        ...(toastStyles as any),
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AppLayout>
      <div className="mb-2 md:mb-0">
        <Breadcrumb items={breadcrumbItems} />
      </div>

      <div className="flex items-center mb-4 md:mb-6 mt-2">
        <h1 className={pageTitleClass}>નવી ટર્નિંગ રિસીવ ઉમેરો</h1>
      </div>

      <div className="flex flex-col gap-6">
        <TurningReceiveForm
          partyOptions={partyOptions}
          openOrders={openOrders}
          openOrdersLoading={openOrdersLoading}
          onPartyChange={handlePartyChange}
          onSubmit={handleSubmit}
          isSubmitting={isSubmitting}
          onCancel={() => navigate(route.turningReceives)}
          submitLabel="સાચવો"
          withRates={withRates}
        />
      </div>
    </AppLayout>
  );
};
export default TurningReceiveCreatePage;
